import React, { Component } from 'react';
import { Divider, HTMLTable, Button, Intent, Tag } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class WebStore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      packages: [
        { id: 1, name: 'Starter Silk Pack', silk: '500 Silk', price: '$5.00', bonus: '+0 Silk', status: 'ACTIVE' },
        { id: 2, name: 'Advanced Silk Pack', silk: '1,000 Silk', price: '$10.00', bonus: '+100 Bonus Silk', status: 'ACTIVE' },
        { id: 3, name: 'Popular Silk Bundle', silk: '2,500 Silk', price: '$25.00', bonus: '+300 Bonus Silk', status: 'ACTIVE' },
        { id: 4, name: 'Pro VIP Silk Pack', silk: '5,000 Silk', price: '$50.00', bonus: '+750 Bonus Silk', status: 'ACTIVE' },
        { id: 5, name: 'Ultimate Whalepack', silk: '10,000 Silk', price: '$100.00', bonus: '+2,000 Bonus Silk', status: 'ACTIVE' },
      ]
    };
  }

  render() {
    return (
      <SideMenuWrapper>
        <h3 className="display-4 font-italic mb-3" style={{ fontSize: '1.5rem', color: '#182026' }}>
          Web Store & Silk Package Management
        </h3>
        <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
          Configure web shop Silk bundles, bonus promotions, and automated payment gateway fulfillment.
        </p>

        <Divider className="mb-4" />

        <HTMLTable bordered condensed striped style={{ width: '100%', fontSize: '0.82rem' }}>
          <thead>
            <tr>
              <th style={{ color: '#182026' }}>Bundle Name</th>
              <th style={{ color: '#182026' }}>Silk Amount</th>
              <th style={{ color: '#182026' }}>Price (USD)</th>
              <th style={{ color: '#182026' }}>Bonus Silk</th>
              <th style={{ color: '#182026' }}>Status</th>
              <th style={{ color: '#182026' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {this.state.packages.map((pkg, i) => (
              <tr key={i}>
                <td className="font-weight-bold" style={{ color: '#182026' }}>{pkg.name}</td>
                <td className="font-mono font-weight-bold" style={{ color: '#106ba3' }}>{pkg.silk}</td>
                <td className="font-mono text-success font-weight-bold">{pkg.price}</td>
                <td className="text-warning">{pkg.bonus}</td>
                <td><Tag intent={Intent.SUCCESS} round>{pkg.status}</Tag></td>
                <td><Button icon="edit" small minimal intent={Intent.PRIMARY} text="Edit" /></td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>
      </SideMenuWrapper>
    );
  }
}
